// extracted by mini-css-extract-plugin
export default {"page":"credits-page_page__AL5GM","title":"credits-page_title__+myt8","balanceCard":"credits-page_balanceCard__4HXF0","sectionTitle":"credits-page_sectionTitle__ydjC+"};